import Tone from 'tone';
import SamplerAmplitudeLFO from './SamplerAmplitudeLFO.js';

const SAMPLER_LIMIT = 3;
const RELEASE_TIME = 0.1;

class SamplerVoice  {
    constructor(voiceNumber=0, sampledInstrument) {
        this.outputNode = new Tone.Gain(1);
        this.voiceNumber = voiceNumber;
        this.ampEnvelope = new Tone.AmplitudeEnvelope(
            10, 10, 1, 100);
        this.ampLFO = new SamplerAmplitudeLFO();
        this.ampEnvelope.connect(this.ampLFO.input);
        this.ampLFO.output.connect(this.outputNode);
        this.crossFade = new Tone.CrossFade(0);
        this.crossFade.connect(this.ampEnvelope);

        this.ampEnvelope.releaseCurve = 'linear';
        this.ampEnvelope.attackCurve = 'linear';
        this.ampEnvelope.decayCurve = 'linear';

        this.samplerToTriggers = {};
        this.samplerToTransposes = {};
        this.idToSampler = {};

        this.samplerLimit = SAMPLER_LIMIT;
    }

    clear(time) {
        this.samplerToTriggers = {};
        this.idToSampler = {};
    }

    connect(node) {
        this.outputNode.connect(node);
    }

    dispose() {
        this.outputNode.dispose();
        this.ampEnvelope.dispose();
        this.outputNode = undefined;
        this.ampEnvelope = undefined;
        this.samplerToTriggers = undefined;
    }

    useSampler(sampler, time, transpose, loopPoints) {
        if (!time) {
            time = Tone.Master.context.currentTime;
        }
        if (this.samplerToTriggers[sampler.id] === undefined ||
            this.samplerToTriggers[sampler.id][transpose] === undefined ||
            this.samplerToTriggers[sampler.id][transpose] === 0)
        {
            this.samplerToTriggers[sampler.id] = {};
            this.samplerToTriggers[sampler.id][transpose] = 0;
        }
        this.samplerToTriggers[sampler.id][transpose]++;
        this.idToSampler[sampler.id] = sampler;
        this.ampLFO.trigger(time, loopPoints, transpose + sampler.transpose);

        if (this.tooManyTriggers() > 0) {
            this.releaseOldestTrigger(sampler, 0, time);
        }
    }

    onVoiceRelease(sampler, transpose) {
        if (this.samplerToTriggers[sampler.id]) {
            delete this.samplerToTriggers[sampler.id][transpose];
        }
    }

    disconnectSampler(sampler, transpose) {
        if (this.samplerToTriggers[sampler.id] === undefined ||
            this.samplerToTriggers[sampler.id][transpose] === undefined) {
            return true;
        }
        if (this.samplerToTriggers[sampler.id][transpose] === 0) {
            delete this.samplerToTriggers[sampler.id][transpose];
            return true;
        }
        return false;
    } 

    isUsed() {
        return Object.keys(this.samplerToTriggers).length > 0;
    }

    isUsingSampler(sampler) {
        let ret = this.samplerToTriggers[sampler.id] === undefined ?
            false : 
            Object.keys(this.samplerToTriggers[sampler.id]).length > 0;
        return ret;
    }

    get totalTriggers() {
        let sum = 0;
        for (let i in this.samplerToTriggers) {
            let triggers = this.samplerToTriggers[i];
            for (let transpose in triggers) {
                sum +=  triggers[transpose];
            }
        }
        return sum;
    }

    tooManyTriggers() {
        return this.totalTriggers - SAMPLER_LIMIT;
    }

    getFromMap(map, i) {
        return Object.keys(map).filter(
            x => map[x] && map[x].length > 0)[i];
    }

    releaseOldestTrigger(sampler, i, time) {
        // release a tiny bit before
        if (time === undefined) {
            time = Tone.Master.context.currentTime;
        } else {
            time = time - 0.005;
            if (time < 0) {
                time = 0;
            }
        }
        
        // first try to kill a sampler that is NOT the current one
        for (let id in this.idToSampler) {
            if (this.idToSampler[id] === sampler) {
              
            }
            let _sampler = this.idToSampler[id].sampler;
            
            let oldestMidi = this.getFromMap(_sampler._activeSources, i);
            if (oldestMidi !== undefined) {
                let freq = new Tone.Midi(oldestMidi).toFrequency();
                _sampler.triggerRelease(new Tone.Midi(oldestMidi).toFrequency(), time, RELEASE_TIME);
                return;
            }
        }

        // otherwise try to kill this samplers current note (i.e. release it)

        let _sampler = sampler.sampler;
        let oldestMidi  = this.getFromMap(_sampler._activeSources, i);
        // console.log('releasing sampler=%s note=%s totalTriggers=%s', sampler.id, oldestMidi, this.totalTriggers, new Date().getTime());
        _sampler.triggerRelease(new Tone.Midi(oldestMidi).toFrequency(), time, RELEASE_TIME);
    }
}


export default SamplerVoice;
